import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useApi } from "@/lib/useApi";
import { useAuthToken } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const LogoutButton = () => {
  const { logout } = useAuthToken();
  const nav = useNavigate();
  return (
    <Button variant="outline" size="sm" onClick={() => { logout(); nav("/", { replace: true }); }} data-testid="btn-logout">
      <LogOut size={14} className="mr-1" /> Esci
    </Button>
  );
};

export const ChangePasswordButton = ({ forced = false }) => {
  const api = useApi();
  const { setToken, logout } = useAuthToken();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.new_password !== f.confirm) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setOpen(false); setF({ current_password: "", new_password: "", confirm: "" });
      setToken(r.data.token);
      toast.success("Password aggiornata");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setOpen(true)} data-testid="btn-change-password"><KeyRound size={14} className="mr-1" /> Password</Button>
      <Dialog open={open || forced} onOpenChange={(v) => !forced && setOpen(v)}>
        <DialogContent className={`max-w-sm ${forced ? "[&>button]:hidden" : ""}`} data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()} onEscapeKeyDown={(e) => forced && e.preventDefault()}>
          <DialogHeader><DialogTitle>{forced ? "Scelga una nuova password" : "Cambia password"}</DialogTitle></DialogHeader>
          {forced && <p className="text-sm text-slate-600" data-testid="cp-forced-note">Sta usando una password temporanea: per continuare ne scelga una nuova. Come password attuale inserisca quella ricevuta via email.</p>}
          <div className="space-y-3">
            <div><Label className="text-xs">Password attuale</Label><Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="cp-current" /></div>
            <div><Label className="text-xs">Nuova password (almeno 6 caratteri)</Label><Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="cp-new" /></div>
            <div><Label className="text-xs">Ripeti nuova password</Label><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="cp-confirm" /></div>
          </div>
          <DialogFooter className="gap-2">{forced && <Button variant="outline" onClick={logout} data-testid="cp-forced-logout">Esci</Button>}<Button disabled={busy || f.new_password.length < 6} onClick={save} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="cp-save">Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
